up.compiler('form.needs-validation', (form: HTMLFormElement) => {
    const cleanup = [];
    
    cleanup.push(up.on(form, 'submit', (event: Event) => {
        if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()

            const fields = form.querySelectorAll('input.form-control, input.form-check-input, select, textarea');

            fields.forEach((field: HTMLFormElement) => {
                up.validate(field);
            });
        }
    }));

    return () => {
        cleanup.forEach(fn => fn());
    }
});